module.exports = __webpack_public_path__ + "img/org.76c592dc.png";